import { render, staticRenderFns } from "./wtSettings.component.vue?vue&type=template&id=8912dd1c&scoped=true&"
import script from "./wtSettings.component.vue?vue&type=script&lang=js&"
export * from "./wtSettings.component.vue?vue&type=script&lang=js&"
import style0 from "./wtSettings.component.vue?vue&type=style&index=0&id=8912dd1c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8912dd1c",
  null
  
)

export default component.exports